module.exports = __webpack_public_path__ + "static/media/primeiro.78ed7f59.png";